import { styled } from '@mui/material/styles';
import { Grid, ListItemText, Typography } from '@mui/material';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '10px',
  lineHeight: '13.35px',
  marginRight: '5px',
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
}));

export const DropdownContainer = styled('div')(() => ({
  position: 'relative',
  maxHeight: '297px',
  overflow: 'none',
  borderRadius: '10px',
}));

export const DropdDownGrid = styled(Grid)(() => ({
  height: '229px',
  overflowY: 'auto',
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '9px !important',
  lineHeight: '13.35px !important',
  padding: 0,
  '& .MuiTypography-root': {
    fontSize: '9px !important',
    color: theme.palette.text.primary,
    padding: 0,
    paddingTop: '4px',
  },
  height: '20px',
}));
